import { TreatmentCategory, Appointment, Treatment } from '../../models/types'

export const getTreatmentIdsFromCategories = (
  categories: TreatmentCategory[],
  treatmentIdsFilter: string[] | undefined
): string[] => {
  const resultTreatmentIds: string[] = []

  resultTreatmentIds.push(
    ...categories.map((t) => t.treatmentsList.map((tt) => tt.id)).flat()
  )

  const filteringTreatmentIds = treatmentIdsFilter
    ? resultTreatmentIds.filter((id) => treatmentIdsFilter?.includes(id))
    : resultTreatmentIds

  return filteringTreatmentIds
}

export const getTreatmentPrice = (selectedAppointment: Appointment | null) => {
  // return 0 only if any of the values are null or undefined
  if (selectedAppointment == null || selectedAppointment.price == null) return 0

  // if reducePrice is undefined/null, return the standard price
  return (
    selectedAppointment.price.reducedPrice ??
    selectedAppointment.price.standardPrice
  )
}

export const getTreatmentIdsFromTreatments = (
  selectedTreatment: Treatment | Treatment[] | null
): string[] => {
  if (selectedTreatment === null) return []

  if (Array.isArray(selectedTreatment)) {
    return selectedTreatment.map((t) => t.id)
  }

  if (selectedTreatment?.id) {
    return [selectedTreatment?.id]
  }

  return []
}

export const getSelectedTreatmentObject = (
  selectedTreatment: Treatment | Treatment[] | null,
  selectedAppointment: Appointment | string | null
): Treatment | null => {
  if (!selectedTreatment && !selectedAppointment) return null
  const treatmentId =
    typeof selectedAppointment === 'string'
      ? selectedAppointment
      : selectedAppointment?.treatmentId

  if (Array.isArray(selectedTreatment)) {
    return selectedTreatment.find((t) => t.id === treatmentId) ?? null
  }

  return selectedTreatment
}
